import { render, staticRenderFns } from "./FCryptoSymbol.vue?vue&type=template&id=a66188ba&"
import script from "./FCryptoSymbol.vue?vue&type=script&lang=js&"
export * from "./FCryptoSymbol.vue?vue&type=script&lang=js&"
import style0 from "./FCryptoSymbol.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports